global.jQuery = $ = require('jquery');
